import { useCheckPermissions } from "@/shared";
import { SaveEgresos,} from "../../shared/saveEgresos"
import { PermissionsEnum } from "@/auth/interfaces";

const CreateEgresoPage = () => {
  useCheckPermissions(PermissionsEnum.api_add_egresoinventario)
  return <SaveEgresos title="Crear Egreso de Inventario" />
}
export default CreateEgresoPage;